module.exports = __webpack_public_path__ + "./static/img/icon-3.c71a357530bbd0ec5fe9b58fa00f3c93.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/join/icon-3.png
// module id = ./client/src/assets/img/join/icon-3.png
// module chunks = 0